import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Link, Redirect } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {}
        }
    }

    submitData = async () => {
        await this.updateBloc.fetchUpdate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.state.dataForm.dependent_status_uuid,
                ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log(response)
                        this.setState({
                            dataForm: response,
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        const queryParams = new URLSearchParams(this.props.location.search)
        this.updateBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }

    componentWillUnmount() {
        this.updateBloc.updateChannel?.unsubscribe()
        this.updateBloc.detailChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Edit Kode Kawin</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Kode <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="dependent_status_code"
                                                    id="dependent_status_code"
                                                    type="text"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm?.dependent_status_code}
                                                />
                                                <AvField
                                                    placeholder=""
                                                    name="uuid"
                                                    id="uuid"
                                                    type="hidden"
                                                    className="form-control"
                                                    value={this.state.dataForm?.dependent_status_uuid}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="dependent_status_name"
                                                    id="dependent_status_name"
                                                    type="text"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm?.dependent_status_name}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            PTKP <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="dependent_status_ptkp"
                                                    id="dependent_status_ptkp"
                                                    type="text"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm?.dependent_status_ptkp}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Kawin Pol <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    placeholder=""
                                                    name="dependent_status_kawin_pol"
                                                    id="dependent_status_kawin_pol"
                                                    type="text"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    value={this.state.dataForm?.dependent_status_kawin_pol}
                                                />
                                            </Col>
                                        </Row>

                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/kode_kawin.html?'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);